const $descriptionScrollButton = document.querySelector('[data-role=scroll-button]') as HTMLElement;
const $testStartContent = document.querySelector('[data-role=test-start-content]') as HTMLElement;
const $testThanksContent = document.querySelector('[data-role=test-thank-content]') as HTMLElement;
const $testResultContent = document.querySelector('[data-role=test-result-content]') as HTMLElement;

$descriptionScrollButton.addEventListener('click', onDescriptionScrollButtonClick);

function onDescriptionScrollButtonClick(event: Event) {
	event.preventDefault();

	$testStartContent.scrollIntoView({ behavior: 'smooth', block: 'start' });
	$testThanksContent.scrollIntoView({ behavior: 'smooth', block: 'start' });
	$testResultContent.scrollIntoView({ behavior: 'smooth', block: 'start' });
}